import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import RawDataTable from "./smartComponents/rawDataTable";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import { actionCreators } from "./redux/sagas/rawDataTable/rawDataTable";
import PollingRequest from "../../utils/polling-request";
import isEmpty from "lodash/isEmpty";
import CoreUiTable from "./smartComponents/rawDataCoreUiTable";
import { DataPoints } from "./smartComponents/dataPoints";

export class RawDataTableModule extends React.Component {
  static propTypes = {
    fetchTableDataSuccess: PropTypes.func.isRequired,
    fetchCurrentUser: PropTypes.func.isRequired,
    setLoading: PropTypes.func,
    updateProgress: PropTypes.func,
    progress: PropTypes.object,
    isLoading: PropTypes.bool,
    showViewAllDataButton: PropTypes.bool,
    showViewAllDataUrl: PropTypes.string,
    showSharedMembersDataButton: PropTypes.bool,
    showSharedMembersUrl: PropTypes.string,
    hideSharedMembersDataButton: PropTypes.bool,
    hideSharedMembersUrl: PropTypes.string,
    queryParams: PropTypes.object,
    headerInfo: PropTypes.array,
    showDataPoints: PropTypes.bool
  };

  componentDidMount() {
    this.startPolling();
  }

  startPolling = () => {
    new PollingRequest({
      query: this.props.queryParams,
      success: this.success,
      progress: this.progress,
      error: this.error
    }).start(() => {
      this.props.setLoading(true);
    });
  };

  success = (response) => {
    let combined = response;
    combined["currentUser"] = this.props.queryParams;
    this.props.fetchTableDataSuccess(response);
    // show ScrollTopButton
    const event = new Event("raw-data-loaded");
    document.dispatchEvent(event);
  };

  error = (response) => {
    console.log(response);
  };

  progress = (progress) => {
    this.props.updateProgress(progress);
  };

  renderLoading() {
    const { progress } = this.props;
    const progressPercent = (progress.current / progress.total) * 100;
    const progressText = isEmpty(progress) ? "" : `${Math.ceil(progressPercent)}%`;

    return <LoadingAnimation height={"100vh"} text={`Loading... ${progressText}`} />;
  }

  render() {
    const { isCoreUiTable = false } = this.props.queryParams;
    return (
      <>
        {this.props.queryParams.showDataPoints ? <DataPoints /> : null}

        <div className="raw-data-table" id={this.props.queryParams.table_name}>
          {this.props.isLoading && this.renderLoading()}
          {!this.props.isLoading && (
            <>
              {!isCoreUiTable ? (
                <div className="md-handson-table">
                  <div className="hot__flex" style={{ width: this.props.queryParams.width }}>
                    <RawDataTable startPolling={this.startPolling} />
                  </div>
                </div>
              ) : (
                <CoreUiTable />
              )}
            </>
          )}
        </div>
      </>
    );
  }
}

export default connect(
  (state) => ({
    isLoading: state.rawDataTable.isLoading,
    headerInfo: state.rawDataTable.headerInfo,
    showViewAllDataButton: state.rawDataTable.showViewAllDataButton,
    showViewAllDataUrl: state.rawDataTable.showViewAllDataUrl,
    showSharedMembersDataButton: state.rawDataTable.showSharedMembersDataButton,
    showSharedMembersUrl: state.rawDataTable.showSharedMembersUrl,
    hideSharedMembersDataButton: state.rawDataTable.hideSharedMembersDataButton,
    hideSharedMembersUrl: state.rawDataTable.hideSharedMembersUrl,
    progress: state.rawDataTable.progress
  }),
  {
    fetchCurrentUser: actionCreators.fetchCurrentUser,
    fetchTableDataSuccess: actionCreators.fetchTableDataSuccess,
    setLoading: actionCreators.setLoading,
    updateProgress: actionCreators.updateProgress
  }
)(RawDataTableModule);
